/** The prepaid credits a visitor can pick at checkout, in whole USD. */
export const GTM_CHECKOUT_AMOUNT = {
    minUsd: 50,
    maxUsd: 150,
    stepUsd: 10,
    defaultUsd: 50,
};
//# sourceMappingURL=gtm-checkout.constants.js.map